// extracted by css-extract-rspack-plugin
module.exports =  {"card":"NewsCard-Fo4J__card","hover":"NewsCard-ME9o__hover","hide":"NewsCard-UGw___hide","news-title":"NewsCard-LsdE__news-title"};